import { mapToRecommendations } from './utils';
import { addAbsolutePosition } from './utils/addAbsolutePosition';
import { addIndexName } from './utils/addIndexName';
import { version } from './version';
export function getLookingSimilar({
  objectIDs,
  recommendClient,
  transformItems = x => x,
  fallbackParameters,
  indexName,
  maxRecommendations,
  queryParameters,
  threshold
}) {
  const queries = objectIDs.map(objectID => ({
    fallbackParameters,
    indexName,
    maxRecommendations,
    objectID,
    queryParameters,
    threshold
  }));
  recommendClient.addAlgoliaAgent('recommend-core', version);
  if (queries.length === 0) {
    return Promise.resolve({
      recommendations: []
    });
  }
  return recommendClient.getLookingSimilar(queries).then(response => mapToRecommendations({
    maxRecommendations,
    hits: response.results.map(result => result.hits),
    nrOfObjs: objectIDs.length,
    queryIDs: response.results.map(res => res.queryID)
  })).then(hits => hits.map(hit => addIndexName(hit, indexName)).map((hit, idx) => addAbsolutePosition(hit, idx))).then(hits => ({
    recommendations: transformItems(hits)
  }));
}